// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 179 ? "main" : chunkId) + ".css?t=1679019840825";
};